<div class="popup modal-header w-100 d-inline-block  pb-0 mb-0">
   
    <div *ngIf="showNext" class="p-4">
      <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      <img src="assets/images/Success.gif" class="success">

      <h1>Booking Update Request Sent!</h1>
      <p class="mb-5">Your booking Amendment is being processed
        Our support team would get in touch shortly
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-resend w-100 " (click)="bsModalRef?.hide()">Done</button>
      </div>
    </div>
  
      <div *ngIf="!showNext">
        <div class="d-flex justify-content-between align-items-center header">
            <p >Edit Date</p>
            <div class="text-right" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
          </div>
        <div class="pt-2">

            <div class="form-input">
              <div class=" d-flex align-items-center form-control ">
                <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.calendar"></fa-icon>
                <input class="date-input" type="text" placeholder="Check In & Out" 
                  [bsConfig]="{ isAnimated: true, showWeekNumbers: false, rangeInputFormat: 'DD-MM-YYYY' }"
                  [(ngModel)]="dateRange" #dp="bsDaterangepicker" bsDaterangepicker (bsValueChange)="onValueChange($event)">
                <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.caretDown"></fa-icon>
        
              </div>
            </div>
        
            <!-- <div class="col-6 form-input">
              <label class="form-label mt-0">Check in<span class="text-danger">*</span> </label>
              <app-input formCtrlName="check_in" (changeEvent)="getDate($event)" [label]="'Check in *'" [formGrp]="form" date
                [required]="true"></app-input>
            </div>
            <div class="col-6 form-input">
              <label class="form-label mt-0">Check out <span class="text-danger">*</span> </label>
              <app-input formCtrlName="check_out" [min]="checkIn" [label]="'Check out *'" [formGrp]="form" date
                [required]="true"></app-input>
            </div> -->
        
            <form [formGroup]="form">
        
              <div class="col-12 form-input mt-2" data-bs-toggle="dropdown">
                <!-- <div class="dropdown-occupants-input">
                  <span *ngIf="occupants!=''">
                    {{occupants}}
                  </span>
                  <span *ngIf="occupants==''" class="fake-placeholder">How many people? <sup>*</sup></span>
                </div> -->
                <app-input formCtrlName="occupants" [label]="'Who is staying? *'" [formGrp]="form" text [required]="true">
                </app-input>
              </div>
        
              <ul class="dropdown-menu" (click)="$event.stopPropagation()">
                <div *ngFor="let occupant of occupant_types" class="d-flex justify-content-between align-items-center pb-3">
                  <div class="d-flex align-items-center">
                    <fa-icon class="dropdown-icon occupants-icon me-3" [icon]="occupant.icon"></fa-icon>
                    <div>
                      <h6 class="dropdown-text">{{occupant.name}}</h6> 
                      <small class="dropdown-subtext">{{occupant.subText}}</small>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <fa-icon (click)="decrement(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretDown">
                    </fa-icon>
                    <input [formControlName]="occupant.name" (keyup)="constructString()" class="dropdown-input" type="number"
                      placeholder="0">
                    <fa-icon (click)="increment(occupant.name)" class="dropdown-icon dropdown-caret" [icon]="icons.caretUp">
                    </fa-icon>
                  </div>
                </div>
              </ul>

              <textarea formControlName="message" placeholder="Enter amendment Message"
              class="form-control  text-body mt-3" cols="10" rows="5">Enter amendment message</textarea>
  
            </form>
        
        
            <div *ngIf="form.valid" class="d-sm-flex booking-info bg-yellow-chip mt-2">
              <div class="align-items-center mb-2">
                <div class="booking-sm-caption mb-2">
                  Duration of stay ({{totalDuration}} {{totalDuration > 1 ? 'nights' : 'night'}})
                </div>
                <div class="ms-auto me-auto">
                  <!-- <h6 class="booking-text-bold mb-1">
                  4 Months, 3 days,
                </h6> -->
                  <p class="booking-sm-caption">
                    {{dateRange[0] | date}} - {{dateRange[1] | date}}
                  </p>
                </div>
              </div>
        
              <div class="align-items-center ms-auto me-auto mb-2">
                <div class="booking-sm-caption mb-2">
                  Guest
                </div>
                <div class="ms-auto me-auto">
                  <h6 class="booking-text-bold mb-1">
                    {{form.value.occupants}}
                  </h6>
                  <!-- <p class="booking-sm-caption">
                  1 pet
                </p> -->
                </div>
              </div>
            </div>
        
          </div>
        
          <div class="mt-3 d-flex justify-content-start">
            <app-button (onclick)="onConfirm()" [disabled]="form.invalid" warning> {{loading ? 'Processing...' : 'Update'}} </app-button>
      
          </div>
      </div>
    </div>
    